// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2Uuox","notes":"Notes_notes__PjiG4"};